import { render, staticRenderFns } from "./hostingPharmacy.vue?vue&type=template&id=2f14f278&scoped=true&"
import script from "./hostingPharmacy.vue?vue&type=script&lang=js&"
export * from "./hostingPharmacy.vue?vue&type=script&lang=js&"
import style0 from "./hostingPharmacy.vue?vue&type=style&index=0&id=2f14f278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14f278",
  null
  
)

export default component.exports